import React from 'react';
import { useConfiguration } from '../../context/configurationContext';
import loadable from '@loadable/component';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);

// The footer's link columns (Terms of Service, Privacy Policy, etc.) come from
// the Console-hosted "footer" content asset, so they can't be edited from this
// codebase. This extra block is added locally so the "Install the app" link
// can ship via code/deploy instead of requiring a Console content edit, while
// still rendering through the same BlockBuilder/markdown pipeline (so it gets
// the same look as the other footer link columns).
const installerAppBlock = {
  blockId: 'installer-app-link',
  blockType: 'footerBlock',
  text: {
    fieldType: 'markdown',
    content:
      process.env.REACT_APP_FORCE_LOCALE === 'en'
        ? '[Install the app 📲](/installer-app)'
        : "[Installer l'app 📲](/installer-app)",
  },
};

const FooterComponent = () => {
  const { footer = {}, topbar } = useConfiguration();

  // If footer asset is not set, let's not render Footer at all.
  if (Object.keys(footer).length === 0) {
    return null;
  }

  // The footer asset does not specify sectionId or sectionType. However, the SectionBuilder
  // expects sectionId and sectionType in order to identify the section. We add those
  // attributes here before passing the asset to SectionBuilder.
  const footerSection = {
    ...footer,
    sectionId: 'footer',
    sectionType: 'footer',
    linkLogoToExternalSite: topbar?.logoLink,
    blocks: [...(footer.blocks || []), installerAppBlock],
  };

  return <SectionBuilder sections={[footerSection]} />;
};

// NOTE: if you want to add dynamic data to FooterComponent,
//       you could just connect this FooterContainer to Redux Store
//
// const mapStateToProps = state => {
//   const { currentUser } = state.user;
//   return { currentUser };
// };
// const FooterContainer = compose(connect(mapStateToProps))(FooterComponent);
// export default FooterContainer;

export default FooterComponent;
